// /**
//  * ribbon-cart.js  (Approach 2 — non-intercepting)
//  *
//  * Watches for a successful Shopify /cart/add and, if the item added was a medal
//  * with a ribbon colour selected, adds the matching ribbon PRODUCT as a second
//  * line item. Does NOT intercept or modify the medal's own add, so product-option
//  * / customizer apps (Easify, Product Customizer: logo, engraving) keep working.
//  *
//  * Config comes from the <script data-ribbon-config> block rendered by
//  * snippets/ribbon-cart.liquid:
//  *   { optionName, noRibbonValue, colorToVariantId: { "Black": 123, ... } }
//  *
//  * Reusable across every medal product that uses the same ribbon option values.
//  */
// (function () {
//   'use strict';

//   var ADD_URL_RE = /\/cart\/add(\.js)?(\?|$)/;

//   // Re-entrancy guards so our own ribbon add is never re-processed.
//   var selfAdding = false;
//   var lastRibbonAddAt = 0;

//   function getConfig() {
//     var el = document.querySelector('[data-ribbon-config]');
//     if (!el) return null;
//     try {
//       var cfg = JSON.parse(el.textContent);
//       if (!cfg || !cfg.colorToVariantId) return null;
//       cfg.noRibbonValue = (cfg.noRibbonValue || 'No Ribbon');
//       cfg.optionName = cfg.optionName || 'Ribbon';
//       return cfg;
//     } catch (e) {
//       return null;
//     }
//   }

//   // Read the currently selected ribbon colour from the option selector,
//   // searching the whole document (in this theme the selector is OUTSIDE the form).
//   function getSelectedRibbonColor(optionName) {
//     var sel = document.querySelector('select[name="options[' + optionName + ']"]');
//     if (sel && sel.value) return sel.value;
//     var radio = document.querySelector('input[name="options[' + optionName + ']"]:checked');
//     if (radio && radio.value) return radio.value;
//     return null;
//   }

//   // Is this variant id one of our ribbon products? (so we never recurse)
//   function isRibbonVariant(cfg, variantId) {
//     var ids = cfg.colorToVariantId;
//     for (var k in ids) {
//       if (Object.prototype.hasOwnProperty.call(ids, k) && String(ids[k]) === String(variantId)) {
//         return true;
//       }
//     }
//     return false;
//   }

//   // Given the JSON body returned by /cart/add, pull out the primary added line.
//   function extractAddedItem(json) {
//     if (!json) return null;
//     if (json.items && json.items.length) return json.items[0]; // {items:[...]} form
//     if (json.id || json.variant_id) return json;                // single-item form
//     return null;
//   }

//   function maybeAddRibbon(addedItem) {
//     if (!addedItem) return;

//     var cfg = getConfig();
//     if (!cfg) return; // not a medal product page

//     var addedVariantId = addedItem.variant_id || addedItem.id;

//     // Never react to our own ribbon add.
//     if (selfAdding) return;
//     if (isRibbonVariant(cfg, addedVariantId)) return;
//     if (Date.now() - lastRibbonAddAt < 800) return; // debounce burst duplicates

//     var color = getSelectedRibbonColor(cfg.optionName);
//     if (!color) return;
//     if (color.toLowerCase() === cfg.noRibbonValue.toLowerCase()) return;

//     var ribbonVariantId = cfg.colorToVariantId[color];
//     if (!ribbonVariantId) return; // colour not mapped

//     var quantity = addedItem.quantity || 1;

//     lastRibbonAddAt = Date.now();
//     selfAdding = true;

//     var body = {
//       items: [{
//         id: parseInt(ribbonVariantId, 10),
//         quantity: quantity,
//         properties: {
//           _bundle: 'ribbon',
//           _ribbon_color: color,
//           _ribbon_for: String(addedVariantId)
//         }
//       }],
//       sections: getCartSectionIds(),
//       sections_url: window.location.pathname
//     };

//     // Use XHR directly so we bypass our own fetch wrapper cleanly.
//     var xhr = new XMLHttpRequest();
//     xhr.open('POST', (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//       ? window.Shopify.routes.root : '/') + 'cart/add.js', true);
//     xhr.setRequestHeader('Content-Type', 'application/json');
//     xhr.setRequestHeader('Accept', 'application/json');
//     xhr.onload = function () {
//       selfAdding = false;
//       try {
//         var data = JSON.parse(xhr.responseText);
//         refreshCartUI(data);
//       } catch (e) {
//         refreshCartUI(null);
//       }
//     };
//     xhr.onerror = function () { selfAdding = false; };
//     xhr.send(JSON.stringify(body));
//   }

//   /* ---------- Cart UI refresh (app/theme agnostic) ---------- */

//   function getCartSectionIds() {
//     var ids = [];
//     var bubble = document.getElementById('cart-icon-bubble');
//     if (bubble) ids.push('cart-icon-bubble');
//     var drawer = document.querySelector('cart-drawer, #CartDrawer');
//     if (drawer) ids.push('cart-drawer');
//     if (!ids.length) ids.push('cart-icon-bubble');
//     return ids;
//   }

//   function replaceSection(id, html) {
//     var selMap = {
//       'cart-icon-bubble': ['#cart-icon-bubble'],
//       'cart-drawer': ['cart-drawer', '#CartDrawer']
//     };
//     var selectors = selMap[id] || ['#shopify-section-' + id];
//     var parsed = new DOMParser().parseFromString(html, 'text/html');
//     selectors.forEach(function (sel) {
//       var target = document.querySelector(sel);
//       var source = parsed.querySelector(sel);
//       if (target && source) target.innerHTML = source.innerHTML;
//     });
//   }

//   function refreshCartUI(data) {
//     if (data && data.sections) {
//       Object.keys(data.sections).forEach(function (id) {
//         if (data.sections[id]) replaceSection(id, data.sections[id]);
//       });
//     }
//     // Let Dawn + any apps know the cart changed so they re-sync counts/drawer.
//     document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//     document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
//     if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
//       try { window.Shopify.onCartUpdate(); } catch (e) {}
//     }
//   }

//   /* ---------- Hook the add-to-cart network calls ---------- */

//   // 1) Wrap fetch
//   var origFetch = window.fetch;
//   if (origFetch) {
//     window.fetch = function (input, init) {
//       var url = (typeof input === 'string') ? input : (input && input.url) || '';
//       var isAdd = ADD_URL_RE.test(url);
//       var p = origFetch.apply(this, arguments);
//       if (isAdd && !selfAdding) {
//         p.then(function (res) {
//           if (!res || !res.ok) return;
//           res.clone().json().then(function (json) {
//             maybeAddRibbon(extractAddedItem(json));
//           }).catch(function () {});
//         }).catch(function () {});
//       }
//       return p;
//     };
//   }

//   // 2) Wrap XMLHttpRequest (apps may use XHR instead of fetch)
//   var origOpen = XMLHttpRequest.prototype.open;
//   var origSend = XMLHttpRequest.prototype.send;
//   XMLHttpRequest.prototype.open = function (method, url) {
//     this.__ribbonIsAdd = ADD_URL_RE.test(url || '');
//     return origOpen.apply(this, arguments);
//   };
//   XMLHttpRequest.prototype.send = function () {
//     if (this.__ribbonIsAdd && !selfAdding) {
//       var xhr = this;
//       xhr.addEventListener('load', function () {
//         if (xhr.status >= 200 && xhr.status < 300) {
//           try {
//             var json = JSON.parse(xhr.responseText);
//             maybeAddRibbon(extractAddedItem(json));
//           } catch (e) {}
//         }
//       });
//     }
//     return origSend.apply(this, arguments);
//   };
// })();

/**
 * ribbon-cart.js  (Approach 2 — non-intercepting)
 *
 * Watches for a successful Shopify /cart/add and, if the item added was a medal
 * with a ribbon colour selected, adds the matching ribbon PRODUCT as a second
 * line item. Does NOT intercept or modify the medal's own add, so product-option
 * / customizer apps (Easify, Product Customizer: logo, engraving) keep working.
 *
 * Config comes from the <script data-ribbon-config> block rendered by
 * snippets/ribbon-cart.liquid:
 *   { optionName, noRibbonValue, colorToVariantId: { "Black": 123, ... } }
 *
 * Reusable across every medal product that uses the same ribbon option values.
 */
(function () {
  'use strict';

  var ADD_URL_RE = /\/cart\/add(\.js)?(\?|$)/;

  // Re-entrancy guards so our own ribbon add is never re-processed.
  var selfAdding = false;
  var lastRibbonAddAt = 0;

  function getConfig() {
    var el = document.querySelector('[data-ribbon-config]');
    if (!el) return null;
    try {
      var cfg = JSON.parse(el.textContent);
      if (!cfg || !cfg.colorToVariantId) return null;
      cfg.noRibbonValue = (cfg.noRibbonValue || 'No Ribbon');
      cfg.optionName = cfg.optionName || 'Ribbon';
      return cfg;
    } catch (e) {
      return null;
    }
  }

  // Read the currently selected ribbon colour from the option selector
  function getSelectedRibbonColor(optionName) {
    if (optionName) {
      var sel = document.querySelector('select[name="options[' + optionName + ']"]');
      if (sel && sel.value) return sel.value;
      var radio = document.querySelector('input[name="options[' + optionName + ']"]:checked');
      if (radio && radio.value) return radio.value;
      var selAlt = document.querySelector('select[data-option-name="' + optionName + '"]');
      if (selAlt && selAlt.value) return selAlt.value;
    }

    // Fallback: search all selects / checked radios whose name contains 'ribbon'
    var selects = document.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].name && selects[i].name.toLowerCase().indexOf('ribbon') !== -1) {
        if (selects[i].value) return selects[i].value;
      }
    }
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].name && radios[j].name.toLowerCase().indexOf('ribbon') !== -1) {
        if (radios[j].value) return radios[j].value;
      }
    }
    return null;
  }

  function isNoRibbonValue(val, noRibbonCfg) {
    if (!val) return true;
    var norm = String(val).trim().toLowerCase();
    if (noRibbonCfg && norm === String(noRibbonCfg).trim().toLowerCase()) return true;
    return norm === 'no ribbon' || norm === 'none' || norm === 'no' || norm === 'no-ribbon';
  }

  // Is this variant id one of our ribbon products? (so we never recurse)
  function isRibbonVariant(cfg, variantId) {
    var ids = cfg.colorToVariantId;
    for (var k in ids) {
      if (Object.prototype.hasOwnProperty.call(ids, k) && String(ids[k]) === String(variantId)) {
        return true;
      }
    }
    return false;
  }

  // Given the JSON body returned by /cart/add, pull out the primary added line.
  function extractAddedItem(json) {
    if (!json) return null;
    if (json.items && json.items.length) return json.items[0]; // {items:[...]} form
    if (json.id || json.variant_id) return json;                // single-item form
    return null;
  }

  function maybeAddRibbon(addedItem) {
    if (!addedItem) return;

    var cfg = getConfig();
    if (!cfg) return; // not a medal product page

    var addedVariantId = addedItem.variant_id || addedItem.id;

    // Never react to our own ribbon add.
    if (selfAdding) return;
    if (isRibbonVariant(cfg, addedVariantId)) return;
    if (Date.now() - lastRibbonAddAt < 800) return; // debounce burst duplicates

    var color = getSelectedRibbonColor(cfg.optionName);
    if (!color) return;
    if (isNoRibbonValue(color, cfg.noRibbonValue)) return;

    // Look up ribbon variant ID (direct or case-insensitive)
    var ribbonVariantId = cfg.colorToVariantId[color];
    if (!ribbonVariantId) {
      var colorLower = String(color).trim().toLowerCase();
      for (var k in cfg.colorToVariantId) {
        if (Object.prototype.hasOwnProperty.call(cfg.colorToVariantId, k) && k.trim().toLowerCase() === colorLower) {
          ribbonVariantId = cfg.colorToVariantId[k];
          break;
        }
      }
    }
    if (!ribbonVariantId) return; // colour not mapped

    var quantity = addedItem.quantity || 1;

    lastRibbonAddAt = Date.now();
    selfAdding = true;

    var body = {
      items: [{
        id: parseInt(ribbonVariantId, 10),
        quantity: quantity,
        properties: {
          _bundle: 'ribbon',
          _ribbon_color: color,
          _ribbon_for: String(addedVariantId)
        }
      }],
      sections: getCartSectionIds(),
      sections_url: window.location.pathname
    };

    // Use XHR directly so we bypass our own fetch wrapper cleanly.
    var xhr = new XMLHttpRequest();
    xhr.open('POST', (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/') + 'cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
      selfAdding = false;
      try {
        var data = JSON.parse(xhr.responseText);
        refreshCartUI(data);
      } catch (e) {
        refreshCartUI(null);
      }
    };
    xhr.onerror = function () { selfAdding = false; };
    xhr.send(JSON.stringify(body));
  }

  /* ---------- Cart UI refresh (app/theme agnostic) ---------- */

  function getCartSectionIds() {
    var ids = [];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) ids.push('cart-icon-bubble');
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (drawer) ids.push('cart-drawer');
    if (!ids.length) ids.push('cart-icon-bubble');
    return ids;
  }

  function replaceSection(id, html) {
    var selMap = {
      'cart-icon-bubble': ['#cart-icon-bubble'],
      'cart-drawer': ['cart-drawer', '#CartDrawer']
    };
    var selectors = selMap[id] || ['#shopify-section-' + id];
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    selectors.forEach(function (sel) {
      var target = document.querySelector(sel);
      var source = parsed.querySelector(sel);
      if (target && source) target.innerHTML = source.innerHTML;
    });
  }

  function refreshCartUI(data) {
    if (data && data.sections) {
      Object.keys(data.sections).forEach(function (id) {
        if (data.sections[id]) replaceSection(id, data.sections[id]);
      });
    }
    // Let Dawn + any apps know the cart changed so they re-sync counts/drawer.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
      try { window.Shopify.onCartUpdate(); } catch (e) {}
    }
  }

  /* ---------- Hook the add-to-cart network calls ---------- */

  // 1) Wrap fetch
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isAdd = ADD_URL_RE.test(url);
      var p = origFetch.apply(this, arguments);
      if (isAdd && !selfAdding) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (json) {
            maybeAddRibbon(extractAddedItem(json));
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  // 2) Wrap XMLHttpRequest (apps may use XHR instead of fetch)
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ribbonIsAdd = ADD_URL_RE.test(url || '');
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__ribbonIsAdd && !selfAdding) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var json = JSON.parse(xhr.responseText);
            maybeAddRibbon(extractAddedItem(json));
          } catch (e) {}
        }
      });
    }
    return origSend.apply(this, arguments);
  };

  /* ---------- Ribbon price display (beside the ribbon dropdown) ---------- */

  // Find the price of the currently selected ribbon colour, case-insensitively.
  function lookupRibbonPrice(cfg, color) {
    if (!cfg || !cfg.priceByColor || !color) return null;
    if (cfg.priceByColor[color]) return cfg.priceByColor[color];
    var lower = String(color).trim().toLowerCase();
    for (var k in cfg.priceByColor) {
      if (Object.prototype.hasOwnProperty.call(cfg.priceByColor, k) &&
          k.trim().toLowerCase() === lower) {
        return cfg.priceByColor[k];
      }
    }
    return null;
  }

  // Locate the ribbon <select> (or checked radio's container) so we can anchor the price next to it.
  function getRibbonControl(optionName) {
    var sel = optionName &&
      document.querySelector('select[name="options[' + optionName + ']"]');
    if (sel) return sel;
    var selects = document.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].name && selects[i].name.toLowerCase().indexOf('ribbon') !== -1) {
        return selects[i];
      }
    }
    var radio = document.querySelector('input[type="radio"]:checked');
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].name && radios[j].name.toLowerCase().indexOf('ribbon') !== -1) {
        return radios[j];
      }
    }
    return radio || null;
  }

  // While true, our own DOM writes are ignored by the MutationObserver so we
  // never loop on ourselves.
  var suppressObserve = false;

  function ensurePriceEl(control) {
    var existing = document.querySelector('[data-ribbon-price]');
    if (existing) return existing;
    var span = document.createElement('span');
    span.setAttribute('data-ribbon-price', '');
    span.className = 'ribbon-price';
    span.style.marginLeft = '3px';
    span.style.fontWeight = '500';
    span.style.fontSize = '16px';
    span.style.whiteSpace = 'nowrap';
    // Prefer to sit next to the option's label; fall back to after the control.
    var label = null;
    var fieldset = control.closest && control.closest('fieldset, .product-form__input');
    if (fieldset) label = fieldset.querySelector('legend, label, .form__label');
    if (label) {
      label.appendChild(span);
    } else if (control.parentNode) {
      control.parentNode.insertBefore(span, control.nextSibling);
    }
    return span;
  }

  // Set text/visibility only when it actually changes (keeps mutations minimal).
  function writePrice(el, text, hidden) {
    if (el.textContent !== text) el.textContent = text;
    if (el.hidden !== hidden) el.hidden = hidden;
  }

  function updateRibbonPrice() {
    var cfg = getConfig();
    if (!cfg || !cfg.priceByColor) return;
    var control = getRibbonControl(cfg.optionName);
    if (!control) return;
    var color = getSelectedRibbonColor(cfg.optionName);

    suppressObserve = true;
    try {
      var priceEl = ensurePriceEl(control);
      if (!priceEl) return;
      if (isNoRibbonValue(color, cfg.noRibbonValue)) {
        writePrice(priceEl, '', true);
        return;
      }
      var price = lookupRibbonPrice(cfg, color);
      if (price && price.formatted) {
        writePrice(priceEl, '+ ' + price.formatted, false);
      } else {
        writePrice(priceEl, '', true);
      }
    } finally {
      // Reset AFTER the observer's microtask has run, so our own writes above
      // are still seen as suppressed.
      setTimeout(function () { suppressObserve = false; }, 0);
    }
  }

  function bindPriceDisplay() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name &&
          e.target.name.toLowerCase().indexOf('ribbon') !== -1) {
        updateRibbonPrice();
      }
    });
    // Re-render after Shopify/theme variant changes may have re-rendered the form.
    document.addEventListener('variant:change', updateRibbonPrice);
    document.addEventListener('on:variant:change', updateRibbonPrice);
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, updateRibbonPrice);
        window.subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, updateRibbonPrice);
      } catch (e) {}
    }

    // The theme re-renders the option block asynchronously (Shopify Section
    // Rendering) on every variant change, which deletes our injected span.
    // Watch the product area and re-inject whenever that happens.
    if (window.MutationObserver) {
      var scope = document.querySelector(
        'product-info, .product__info-container, .product__info-wrapper, main, #MainContent'
      ) || document.body;
      var pending = null;
      var observer = new MutationObserver(function () {
        if (suppressObserve) return;
        if (pending) return;
        pending = setTimeout(function () {
          pending = null;
          updateRibbonPrice();
        }, 50);
      });
      observer.observe(scope, { childList: true, subtree: true });
    }

    updateRibbonPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindPriceDisplay);
  } else {
    bindPriceDisplay();
  }
})();